// extracted by mini-css-extract-plugin
export default {"lineSlotContainer":"_1Poze","slotName":"U9udH","slotStakes":"_2jP-O","matchesSlotName":"_1P17C","outrightMatch":"IcQ2F","disabledIcon":"KPiaO"};